import { render, staticRenderFns } from "./storeSwitchIdentity.vue?vue&type=template&id=3d6b2397&scoped=true&"
import script from "./storeSwitchIdentity.vue?vue&type=script&lang=babel&"
export * from "./storeSwitchIdentity.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b2397",
  null
  
)

export default component.exports